import { ThreatType } from '@/api/rest/resources/types/fact';

import { HABITAT_INTACTNESS_THREAT_LAYER_OPTIONS, MAP_TYPE } from './constants';
import { GeojsonSourceLayer, RasterSourceLayer } from './MapLayer';

type HabitatIntactnessThreatLayersProps = {
  threatLayers: ThreatType[];
};

export const HabitatIntactnessThreatLayers = ({ threatLayers }: HabitatIntactnessThreatLayersProps) => {
  return (
    <>
      {threatLayers.map((threat) => (
        <div key={threat}>
          <ThreatMapLayer threat={threat} />
        </div>
      ))}
    </>
  );
};

const ThreatMapLayer = ({ threat }: { threat: ThreatType }) => {
  const threatLayer = HABITAT_INTACTNESS_THREAT_LAYER_OPTIONS.find((layer) => layer?.layerSubType === threat);

  switch (threatLayer?.type) {
    case MAP_TYPE.raster:
      return <RasterSourceLayer layer={threatLayer} />;
    case MAP_TYPE.geojson:
      return <GeojsonSourceLayer layer={threatLayer} />;
    default:
      return null;
  }
};
